import { render, staticRenderFns } from "./GogoReactRuntimeRouterView.vue?vue&type=template&id=ab8a9774&scoped=true"
import script from "./GogoReactRuntimeRouterView.vue?vue&type=script&lang=ts"
export * from "./GogoReactRuntimeRouterView.vue?vue&type=script&lang=ts"
import style0 from "./GogoReactRuntimeRouterView.vue?vue&type=style&index=0&id=ab8a9774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8a9774",
  null
  
)

export default component.exports